@if (loading()) {
  <p-skeleton height="100%" width="100%"></p-skeleton>
} @else {
  <p-image 
    [src]="imageUrl()" 
    [alt]="alt()" 
    [imageClass]="imgClass()"
    [preview]="preview() && !isPlaceholder()"
    class="w-full h-full"
    (onImageError)="handleError()">
  </p-image>
}
